import React, { useState, createContext } from 'react';
import { API } from 'aws-amplify';
import { useApiError } from './ApiErrorProvider';
import { useAuth } from './Auth';
import { error } from '../constants/bindings';
import { NotificationInteface } from '../models/NotificationInterface';
import { generateNextNMonths } from '../helpers/dateHelpers';

const NotificationsContext = createContext({ 
  loading: false, 
  notifications: {} as NotificationInteface,
  outlookAuthCodeChannel: {} as BroadcastChannel,
  getNotifications: () => {}, 
  updateNotificationViewed: (blockYear, blockMonth, event, notificationId: number) => {}
});

export const NotificationsProvider = (props) => {
  const { user } = useAuth();
  const {setErrorCode} = useApiError();
  const [loading, setLoading] = useState(false);
  const [notifications, setNotifications] = useState<any>();
  const outlookAuthCodeChannel = props.outlookAuthCodeChannel;

  const getNotifications = async () => {
    if (!user) {
      return;
    }
    setLoading(true);
    try {
      const nextMonth = generateNextNMonths()[0].monthNumber;
      const yearForNextMonth = generateNextNMonths()[0].year;
      const requestObject = {
        body: {
          year: yearForNextMonth,
          month: nextMonth
        }
      };
      const NotificationsRaw = await API.post('crewlife', '/notification/retrieve', requestObject);
      setNotifications({ result: NotificationsRaw.result.map(notification => ({
        ...notification,
        year: parseInt(notification.notificationYear),
        month: parseInt(notification.notificationMonth)
      })) });
      setLoading(false);
    } catch (e:any) {
      if( e.response?.status) { setErrorCode(e.response?.status); }
      else { setErrorCode(error.DEFAULT); }
    }
    finally {
      setLoading(false);
    }
  };

  const updateNotificationViewed = async (blockYear, blockMonth, event, notificationId) => {
    if(!user) {
      return;
    }

    if(!blockYear || !blockMonth) {
      return;
    }

    const requestObject = {
      body: {
        "year": blockYear,
        "month": blockMonth,
        "notificationevent": event,
        "notificationId": notificationId
      }
    };

    try {
      await API.post('crewlife', '/notification/update', requestObject);
    } catch (e: any) {
      if( e.response?.status) { setErrorCode(e.response?.status); }
      else { setErrorCode(error.DEFAULT); }
    }
  };

  return (
    <NotificationsContext.Provider
      value={{
        loading,
        notifications,
        outlookAuthCodeChannel,
        getNotifications,
        updateNotificationViewed
      }} >
      {props.children}
    </NotificationsContext.Provider>
  );
};

export const useNotifications = () => {
  return React.useContext(NotificationsContext);
};
